// extracted by mini-css-extract-plugin
module.exports = {"EndorsedBy":"EndorsedBy_EndorsedBy__g5eWA"};